/**
 * The colleagues a piece of work can be assigned to.
 *
 * A subscription rather than a one-off read, because the team is edited in
 * Settings while the rest of the app stays open — somebody added this morning
 * should be pickable without a reload.
 *
 * Failure is an empty list rather than an error: a dropdown that cannot offer
 * anybody is a mild problem, and it must not take a screen down with it. What it
 * does mean is that the owner already on a record has to survive an empty
 * team — see `PostModal`.
 */
import { useEffect, useState } from 'react'
import { subscribeToTeam } from './repository/crmUserRepository'

export interface TeamMember {
  email: string
  displayName: string
}

export function useTeamMembers(): TeamMember[] {
  const [team, setTeam] = useState<TeamMember[]>([])

  useEffect(
    () =>
      subscribeToTeam(
        (users) => setTeam(users.map((u) => ({ email: u.email, displayName: u.displayName }))),
        () => setTeam([]),
      ),
    [],
  )

  return team
}
